module.exports = __webpack_public_path__ + "img/como-funciona.ffa106be.jpg";